import styled from 'styled-components'

import Col from '../../atoms/Col'

const CardWrapper = styled(Col)`
  flex: 1 1 100%;
  padding-bottom: ${props => props.theme.gutter * 2}px;

  @media (max-width: 767.9px) {
    padding-left: ${props => (props.version === 1 ? '0' : '')};
    padding-right: ${props => (props.version === 1 ? '0' : '')};
  }

  @media (min-width: 992px) {
    flex: ${props => (props.fullWidth ? '1 1 100%' : '0 0 50%')};
    max-width: ${props => (props.fullWidth ? '100%' : '50%')};
  }

  @media (min-width: 1400px) {
    flex: ${props => props.fullWidth ? '1 1 100%' : (props.version === 1 ? '' : '0 0 33.33%')};
    max-width: ${props => props.fullWidth ? '1 1 100%' : (props.version === 1 ? '' : '33.33%')};
  }
`

export default CardWrapper
